/**
 * Score interpretation labels — used across pipeline and dashboard.
 */

export interface ScoreLabel {
  text: string;
  color: string;
  emoji: string;
}

export function getScoreLabel(score: number): ScoreLabel {
  if (score >= 80) return { text: 'Exceptional', color: '#22c55e', emoji: '🚀' };
  if (score >= 60) return { text: 'Strong foundation', color: '#22c55e', emoji: '✅' };
  if (score >= 40) return { text: 'Promising — risks to fix', color: '#f97316', emoji: '⚠️' };
  return { text: 'Needs significant work', color: '#ef4444', emoji: '🔴' };
}

/** Score dimension descriptions for tooltips/subtitles */
export const SCORE_DESCRIPTIONS: Record<string, string> = {
  'Clarity Score': 'How well-defined your problem and solution are',
  'Market Size': 'Size of the addressable market for this niche',
  'Competition': 'Intensity of existing competition (lower = more room)',
  'Timing': 'How good the timing is for this idea right now',
  'Monetization': 'Strength of your revenue model and pricing',
  'Execution': 'Feasibility given your budget, skills, and timeline',
};
